module.exports = __webpack_public_path__ + "assets/icon-cancel-deselected.d6bf77f8.svg";